module.exports = __webpack_public_path__ + "img/own.8737ac98.jpg";